import React from "react"
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"
import Slider from "react-slick"
import * as styles from "./richtext.module.css"

const LandingCarousel = ({ blok }) => {
  // console.log(blok)

  const settings = {
    autoplay: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  const hotelImage = (image) => (
    <div {...storyblokEditable(image)} key={image.id}>
      { image.filename &&
        <img className={`w-full h-[440px] ${blok.keepImageRatio ? 'object-contain' : 'object-cover'}`} loading="lazy" src={`${image?.filename}/m/0x800`} alt={image.alt} />
      }
    </div>
  )
  
  return (

    <section id={blok?.id} {...storyblokEditable(blok)} className="" 
      style={{
        paddingTop: `${blok.paddingTop}px`, paddingBottom: `${blok.paddingBottom}px`, 
        marginTop: `${blok.marginTop}px`, marginBottom: `${blok.marginBottom}px`, 
        backgroundColor: `${blok.bgColor?.color}`, color: `${blok.textColor?.color}` }}>
      <div className={`container max-w-screen-xl mx-auto py-5 flex flex-wrap ${['top','bottom'].includes(blok.carouselPos) ? 'flex-col' : ''}`}>
        <div className={`w-full px-6
          ${['left','right'].includes(blok.carouselPos) ? 'md:w-1/2' : ''}
          ${['right', 'bottom'].includes(blok.carouselPos) ? 'order-2': 'order-1'}`}>
          <div className="slider-container">
            <Slider {...settings}>{blok.images.map(image => (hotelImage(image)))}</Slider>
          </div>
        </div>
        <div className={`w-full 
          ${['left','right'].includes(blok.carouselPos) ? 'md:w-1/2' : ''}
          ${['right', 'bottom'].includes(blok.carouselPos) ? 'order-1': 'order-2'}`}>
          <div className={`p-8 ${['top','bottom'].includes(blok.carouselPos) ? 'md:flex' : ''} ${blok.titlePos != 'left' ? 'md:flex-col' : ''}`}>
            <h3 className={`text-3xl font-bold font-serif ${blok.titlePos == 'left' ? 'md:w-1/2 mt-8' : ''}`}>{blok.title}</h3>
            <div className={`${blok.titlePos == 'left' ? 'md:w-1/2' : ''} ${styles.richText}`} dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
          </div>
        </div>
      </div>
    </section>
  )
};

export default LandingCarousel;
